<template>
    <div id="app">
        <header>
            <img :src="headerBanner" style="width: 100%" alt="查询服务" />
        </header>
        <keep-alive :include="['InspectionDeclaration']">
            <router-view />
        </keep-alive>
    </div>
</template>
<script>
export default {
    data() {
        return {
            headerBanner: `mobile/img/${process.env.VUE_APP_city}/banner-inspection.png`
        }
    }
}
</script>
